import script from "./TRSaveButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TRSaveButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__